import { UserOrganizationModel } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";
export class UserOrganizationRepo extends BaseDataRepository<UserOrganizationModel> {
  protected baseUrl = 'userorganization';

  async getByUserIdAsync(userId: number): Promise<number[]> {
    const response = await this.client.get(`${this.baseUrl}/GetByUserId/${userId}`);
    return this.handleResponse<number[]>(response)!;
  }
}

export default UserOrganizationRepo;
